import { useState } from "react";

export function Modal({ title, onClose, children, footer, size = "default" }) {
  // size: "default" (Standard ~500-600px), "large" (800px), "xlarge" (1000px)
  const widths = { default: undefined, large: "800px", xlarge: "1000px" };
  const w = widths[size];
  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={w ? { maxWidth: w, width: "90vw" } : undefined}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="btn btn-ghost btn-icon" title="Schließen" aria-label="Schließen" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}

export function Badge({ status }) {
  const labels = {
    geplant: "Geplant", eingeladen: "Eingeladen",
    durchgefuehrt: "Durchgeführt", abgesagt: "Abgesagt",
    geschlossen_beschlussunfaehig: "Beschlussunfähig geschlossen",
    offen: "Offen", in_bearbeitung: "In Bearbeitung",
    erledigt: "Erledigt", abgelehnt: "Abgelehnt",
  };
  return <span className={`badge badge-${status}`}>{labels[status] || status}</span>;
}

export function TopTypBadge({ typ }) {
  const labels = { standard: "Standard", information: "Information", beschluss: "Beschluss" };
  const cls = { beschluss: "top-typ-beschluss", information: "top-typ-information" };
  return <span className={cls[typ] || ""}>{labels[typ] || typ}</span>;
}

export function ConfirmModal({ message, onConfirm, onClose }) {
  return (
    <Modal title="Bestätigung" onClose={onClose}
      footer={<>
        <button className="btn btn-secondary" onClick={onClose}>Abbrechen</button>
        <button className="btn btn-danger" onClick={() => { onConfirm(); onClose(); }}>Löschen</button>
      </>}>
      <p>{message}</p>
    </Modal>
  );
}

export function Spinner() {
  return <div style={{ textAlign: "center", padding: 40, color: "#999" }}>Lädt…</div>;
}

export function Alert({ type = "error", children }) {
  return <div className={`alert alert-${type}`}>{children}</div>;
}

export function FormGroup({ label, children, id }) {
  // htmlFor/id-Verknüpfung ist optional (id-Prop) - bestehende Aufrufstellen
  // ohne id-Angabe verhalten sich exakt wie vorher (kein Risiko, etwas zu
  // brechen). Neue/geänderte Formularfelder sollten id vergeben, damit
  // Screenreader Label und Eingabefeld korrekt zuordnen können.
  return (
    <div className="form-group">
      <label className="form-label" htmlFor={id}>{label}</label>
      {children}
    </div>
  );
}

export function useModal() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  return {
    open, data,
    show: (d) => { setData(d); setOpen(true); },
    hide: () => { setOpen(false); setData(null); },
  };
}
